import React, { useEffect } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchRestaurantDetails } from "../actions/restaurantActions";
import { PageHeaderBar, PageHeaderTitle, PageHeaderDescription } from "../components/PageHeader";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import RestaurantOverview from "../components/overview/RestaurantOverview";

/* The numbers that used to sit under the restaurant home - reservations over
   time, their statuses, the busiest weekdays and hours - on a page of their
   own, so the home can be about creating restaurants and managing plans. */

const Page = styled.div`
  width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 24px 28px 36px;
  background: #fff;

  @media (max-width: 768px) {
    padding: 16px 12px 28px;
  }
`;

export default function RestaurantStatistics() {
  const { t } = useTranslation();
  const { restaurant_id: restaurantId } = useParams();
  const dispatch = useDispatch();
  const { restaurants: restaurant, error } = useSelector(state => state.restaurantDetails);
  const isThisRestaurant = Boolean(restaurant) && String(restaurant.id) === String(restaurantId);

  useEffect(() => {
    if (restaurantId && !isThisRestaurant) dispatch(fetchRestaurantDetails(restaurantId));
  }, [dispatch, restaurantId, isThisRestaurant]);

  return (
    <Page>
      <PageHeaderBar>
        <div>
          <PageHeaderTitle>{t("ui.screens.restaurantStatistics.title")}</PageHeaderTitle>
          <PageHeaderDescription>{t("ui.screens.restaurantStatistics.description")}</PageHeaderDescription>
        </div>
      </PageHeaderBar>
      {isThisRestaurant ? (
        <RestaurantOverview restaurant={restaurant} />
      ) : error ? (
        <Messages variant="danger">{error}</Messages>
      ) : (
        <Loader />
      )}
    </Page>
  );
}
